import { render } from "./SearchResultsContact.vue?vue&type=template&id=a21e4a20&scoped=true"
import script from "./SearchResultsContact.vue?vue&type=script&lang=js"
export * from "./SearchResultsContact.vue?vue&type=script&lang=js"

import "./SearchResultsContact.vue?vue&type=style&index=0&id=a21e4a20&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21e4a20"]])

export default __exports__